import {Injectable} from '@angular/core';

@Injectable()
export class GuidService {

  // Constructor
  constructor() {
  };


  // Stores generated guids
  guids: any[] = [];


  // Generates a GUID and checks if that GUID has already been generated by checking it against the guids array and returns a unique identifier
  getGuid: Function = () => {

    // Get a new guid
    let newGuid = this.createUUID();

    // Check if the guid is already in the guids array
    let isUnique = this.guids.indexOf(newGuid) == -1;

    // If the guid was unique
    if (isUnique) {

      // Push it the guids array so it will not be used again
      this.guids.push(newGuid);

      // Return the new guid
      return newGuid;

    } else {

      // Otherwise run this function again.  Btw the changes of this block being used are astronomical, it's essentially here for kicks and grins.
      this.getGuid();
    }

  }

  // Generates a simple GUID that is only used for front end DOM purposes. 
  // NEVER CALL THIS FOR ANYTHING GOING TO THE BACKEND
  getSimpleGuid: Function = () => {

    // generate a number at least 1000 and that will expand as array grows
    let newGuid = "GUID-" + (this.rand(1000 + this.guids.length) + 1000);

    // Check if the guid is already in the guids array
    let isUnique = this.guids.indexOf(newGuid) == -1;

    // If the guid was unique
    if (isUnique) {

      // Push it the guids array so it will not be used again
      this.guids.push(newGuid);

      // Return the new guid
      return newGuid;

    } else {

      // Otherwise run this function again.  Btw the changes of this block being used are astronomical, it's essentially here for kicks and grins.
      this.getGuid();
    }

  }

  createUUID: Function = () => {

    var dg = new Date(1582, 10, 15, 0, 0, 0, 0);
    var dc = new Date();
    var t = dc.getTime() - dg.getTime();
    var h = '-';
    var tl = this.getIntegerBits(t, 0, 31);
    var tm = this.getIntegerBits(t, 32, 47);
    var thv = this.getIntegerBits(t, 48, 59) + '1'; // version 1, security version is 2
    var csar = this.getIntegerBits(this.rand(4095), 0, 7);
    var csl = this.getIntegerBits(this.rand(4095), 0, 7);

    // since detection of anything about the machine/browser is far to buggy,
    // include some more random numbers here
    // if NIC or an IP can be obtained reliably, that should be put in
    // here instead.
    var n = this.getIntegerBits(this.rand(8191), 0, 7) +
      this.getIntegerBits(this.rand(8191), 8, 15) +
      this.getIntegerBits(this.rand(8191), 0, 7) +
      this.getIntegerBits(this.rand(8191), 8, 15) +
      this.getIntegerBits(this.rand(8191), 0, 15); // this last number is two octets long
    return tl + h + tm + h + thv + h + csar + csl + h + n;
  }


  getIntegerBits: Function = (val, start, end) => {
    var base16 = this.returnBase(val, 16);
    var quadArray = new Array();
    var quadString = '';
    var i = 0;
    for (i = 0; i < base16.length; i++) {
      quadArray.push(base16.substring(i, i + 1));
    }
    for (i = Math.floor(start / 4); i <= Math.floor(end / 4); i++) {
      if (!quadArray[i] || quadArray[i] == '') quadString += '0';
      else quadString += quadArray[i];
    }
    return quadString;
  }


  returnBase: Function = (number, base) => {
    return (number).toString(base).toUpperCase();
  }

  rand: Function = max => {
    return Math.floor(Math.random() * (max + 1));
  }
}